module.exports = __webpack_public_path__ + "static/pattern-green-31d8278cb0724de8ac2dc9a54c1bb9b3.svg";